import { useMemo } from "react";
import useActivePlans from "./useActivePlans";
import useBackendDeniedPlanIds from "./useBackendDeniedPlanIds";

/**
 * `useActivePlans` minus the plans the backend refused with a 403 (R-1856).
 * Customize/upgrade flows must resolve ownership against this list, or they
 * keep retargeting a plan the backend will never accept.
 */
export default function useAllowedActivePlans() {
  const { activePlans, isLoading } = useActivePlans();
  const deniedPlanIds = useBackendDeniedPlanIds();
  const allowedActivePlans = useMemo(
    () => activePlans.filter((plan) => !deniedPlanIds.has(plan.id)),
    [activePlans, deniedPlanIds]
  );
  return { activePlans: allowedActivePlans, isLoading };
}
